"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initModal = initModal;
const helpers_1 = require("../../../../scripts/helpers");
const checkAddressBar_1 = __importDefault(require("./checkAddressBar"));
const BREAKPOINT_DEFAULT = 577;
const BREAKPOINT_NOT_DESKTOP = 1199.98;
/** Инициализирует мобильные модальные окна под айфоны на базе hystmodal. */
function initModal() {
    /** Всё кроме desktop. */
    if (window.innerWidth <= BREAKPOINT_NOT_DESKTOP) {
        (0, checkAddressBar_1.default)();
    }
    window.modal = new window.HystModal({
        linkAttributeName: 'data-hystmodal',
        afterClose: (modal) => {
            window.dispatchEvent(new CustomEvent('hystmodal-closed', {
                detail: { modal },
            }));
        },
        beforeOpen: (modal) => {
            if (!modal.openedWindow.classList.contains('modal--iphone'))
                return;
            let breakpoint = BREAKPOINT_DEFAULT;
            if (modal.openedWindow.hasAttribute('data-breakpoint-theme-iphone')) {
                breakpoint = Number(modal.openedWindow.getAttribute('data-breakpoint-theme-iphone'));
            }
            /**
             * Оболочка основного контента модального окна.
             *
             * @type {HTMLElement}
             */
            const $modalWindow = modal._modalBlock;
            /**
             * Состояние модалки.
             *
             * @type {boolean}
             */
            let nowClosing = false;
            /* Необходимое обнуление */
            $modalWindow.style.top = '';
            const init = () => {
                /**
                 * Главная оболочка модального окна.
                 *
                 * @type {HTMLElement & { update?: () => void }}
                 */
                const $parentModalEl = (0, helpers_1.closest)(modal._modalBlock, '.modal');
                let offsetY = 0;
                let offsetX = 0;
                let initialTopPosition = 0;
                let diffTop = 0;
                /**
                 * Обновляет позиции модального окна с анимацией.
                 *
                 * @param {string} newTop
                 */
                function updateModalPosition(newTop) {
                    $modalWindow.classList.add('modal__window--animated');
                    requestAnimationFrame(() => {
                        $modalWindow.style.top = newTop;
                        const initialInnerHeight = window.innerHeight;
                        /**
                         * Слушатель изменения размеров окна для коррекции позиции окна.
                         *
                         * @type {ResizeObserver}
                         */
                        const resizeObserver = new ResizeObserver(() => {
                            const currentHeight = window.innerHeight;
                            if (Math.abs(currentHeight - initialInnerHeight) > 50) {
                                /* Если высота окна изменилась, корректируем позицию top */
                                const currentTop = parseInt($modalWindow.style.top, 10);
                                $modalWindow.style.top = `${currentTop - (currentHeight - initialInnerHeight)}px`;
                            }
                        });
                        resizeObserver.observe(document.body);
                        setTimeout(() => {
                            $modalWindow.classList.remove('modal__window--animated');
                            resizeObserver.disconnect();
                        }, 175);
                    });
                }
                $parentModalEl.update = () => {
                    /**
                     * Текущее значение top.
                     *
                     * @type {string}
                     */
                    const lastTop = $modalWindow.style.top;
                    /* Необходимое обнуление */
                    $modalWindow.style.top = '';
                    /**
                     * Новое значение top.
                     *
                     * @type {string}
                     */
                    const newTop = `${$modalWindow.offsetTop}px`;
                    $modalWindow.style.top = lastTop;
                    updateModalPosition(newTop);
                };
                requestAnimationFrame(() => {
                    $modalWindow.style.top = `${$modalWindow.offsetTop}px`;
                    requestAnimationFrame(() => {
                        $parentModalEl.update && $parentModalEl.update();
                    });
                });
                let $scrollElement = null;
                let scrollElementClassname = '';
                $scrollElement = $modalWindow.querySelector('.modal__scroll-element');
                if ($scrollElement)
                    scrollElementClassname = '.modal__scroll-element';
                if (!$scrollElement) {
                    $scrollElement = $modalWindow.querySelector('.modal__scroll-element--sm-down');
                    if ($scrollElement)
                        scrollElementClassname = '.modal__scroll-element--sm-down';
                }
                /* Swipe down */
                let touchstartY = 0;
                let touchendY = 0;
                let startTouch = null;
                let endTouch = null;
                let isScrollInScrollElement = false;
                /**
                 * Обрабатывает и отлавливает событие свайпа.
                 *
                 * @param {TouchEvent} e
                 */
                const handleSwipe = (e) => {
                    if ((0, helpers_1.closest)(e.target, '.modal__inner-scroll'))
                        return;
                    if (touchendY > touchstartY + 10 && endTouch - startTouch < 150) {
                        if (!$scrollElement || ($scrollElement && $scrollElement.scrollTop <= 1)) {
                            nowClosing = true;
                            $modalWindow.classList.add('modal__window--animated');
                            requestAnimationFrame(() => {
                                $modalWindow.style.top = `${window.innerHeight}px`;
                            });
                            setTimeout(() => {
                                $modalWindow.classList.remove('modal__window--animated');
                                nowClosing = false;
                                modal.close();
                            }, 175);
                        }
                    }
                };
                $modalWindow.addEventListener('touchstart', (e) => {
                    if (window.innerWidth < breakpoint) {
                        const touch = e.targetTouches[0];
                        offsetY = touch.pageY - $modalWindow.offsetTop;
                        offsetX = touch.pageX - $modalWindow.offsetLeft;
                        initialTopPosition = $modalWindow.offsetTop;
                        const y = touch.pageY;
                        let topValue = y - offsetY;
                        diffTop = topValue - initialTopPosition;
                        touchstartY = e.changedTouches[0].screenY;
                        startTouch = new Date().getTime();
                    }
                }, false);
                $modalWindow.addEventListener('touchend', (event) => {
                    touchendY = event.changedTouches[0].screenY;
                    endTouch = new Date().getTime();
                    if (!isScrollInScrollElement)
                        handleSwipe(event);
                    isScrollInScrollElement = false;
                }, false);
                $modalWindow.addEventListener('touchmove', (e) => {
                    if (window.innerWidth < breakpoint &&
                        !$modalWindow.classList.contains('modal__no-touch-move') &&
                        !e.target.closest('.modal__inner-scroll')) {
                        e.stopPropagation();
                        if (e.targetTouches.length === 1 && !nowClosing) {
                            const touch = e.targetTouches[0];
                            const y = touch.pageY;
                            let topValue = y - offsetY;
                            diffTop = topValue - initialTopPosition;
                            if (diffTop > 0) {
                                if (!$scrollElement ||
                                    ($scrollElement &&
                                        ($scrollElement.scrollTop <= 1 || !(0, helpers_1.closest)(e.target, scrollElementClassname)))) {
                                    if (!isScrollInScrollElement) {
                                        e.preventDefault();
                                        $modalWindow.classList.add('modal__window--dragged');
                                        requestAnimationFrame(() => {
                                            $modalWindow.style.top = `${topValue}px`;
                                        });
                                    }
                                }
                                else {
                                    isScrollInScrollElement = true;
                                }
                            }
                            else if (!$scrollElement ||
                                ($scrollElement &&
                                    $scrollElement.scrollTop >= $scrollElement.scrollHeight - $scrollElement.offsetHeight - 1) ||
                                !(0, helpers_1.closest)(e.target, scrollElementClassname)) {
                                if (!isScrollInScrollElement) {
                                    if (diffTop > -100) {
                                        e.preventDefault();
                                        $modalWindow.classList.add('modal__window--dragged');
                                        topValue = y - offsetY - diffTop * 0.8;
                                        requestAnimationFrame(() => {
                                            $modalWindow.style.top = `${topValue}px`;
                                        });
                                    }
                                }
                            }
                            else {
                                isScrollInScrollElement = true;
                            }
                        }
                    }
                });
                $modalWindow.addEventListener('touchend', (e) => {
                    if (window.innerWidth < breakpoint && !e.target.closest('.modal__inner-scroll')) {
                        if (!nowClosing) {
                            if (diffTop > $modalWindow.scrollHeight * 0.5) {
                                $modalWindow.classList.add('modal__window--animated');
                                requestAnimationFrame(() => {
                                    $modalWindow.style.top = `${window.innerHeight}px`;
                                });
                                setTimeout(() => {
                                    $modalWindow.classList.remove('modal__window--animated');
                                    $modalWindow.style.top = '';
                                }, 300);
                                modal.close();
                            }
                            else {
                                $modalWindow.classList.remove('modal__window--dragged');
                                $modalWindow.classList.add('modal__window--animated');
                                requestAnimationFrame(() => {
                                    $modalWindow.style.top = `${initialTopPosition}px`;
                                });
                                setTimeout(() => {
                                    $modalWindow.classList.remove('modal__window--animated');
                                }, 300);
                            }
                        }
                    }
                });
                $modalWindow.setAttribute('data-inited', '');
            };
            if ($modalWindow.getAttribute('data-inited') !== '')
                init();
        },
    });
}
